import React from 'react';

/**
 * RecommendationCardSkeleton
 *
 * Placeholder skeleton for loading state of recommendation cards.
 */
const RecommendationCardSkeleton = () => (
  <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 bg-gray-50 dark:bg-gray-800 animate-pulse">
    <div className="flex justify-between mb-3">
      <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full w-16" />
      <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-20" />
    </div>
    <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2" />
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full mb-3" />
    <div className="space-y-1 mb-4">
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded" />
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded" />
    </div>
  </div>
);

export default RecommendationCardSkeleton;


